import * as types from "../actions/types/transaction.types";
import moment from "moment";

const initialState = {
  isRetry: false,
  initialTransactionList: [],
  transactionList: [],
  netCashAnalytics: {},
  netCashAnalyticsState: "idle",
  netCashAnalyticsErrorMessage: "",
  netCashAnalyticsErrorCode: "",
  loadingFirestoreTransactionByDate: false,
  errorMessage: "",
  transactionState: "idle",
  errorModal: false,
  loadMoreState: "idle",
  loadMoreScheduledTransactionState: "idle",
  pageSizeCount: 0,
  pageNumCount: 0,
  loadTransactionsByDate: "idle",
  bankStartDate: moment().startOf("month"),
  bankEndDate: moment().endOf("month"),
  singleBeneficiaryTransactionState: "idle",
  singleBeneficiaryTransactionsList: [],
  loadMoreBeneficiaryTransactionsState: "idle",
  dateFilterTransactions: false,
  exportOptions: "",
  fileType: "",
  dateFilterActive: false,
  filterStartDateValue: null,
  filterEndDateValue: null,
  exportState: "idle",
  singleTransactionInfo: {},
  getCategoriesState: "idle",
  categories: [],
  getTagsState: "idle",
  tags: [],
  fetchScheduledPaymentsState: "loading",
  scheduledPaymentsList: [],
  totalScheduledPaymentsInStore: 0,
  analyticsTransactionsList: [],
  refreshTransactionsState: "idle",
  bulkTransactionList: [],
  checkBalance: false,
  oldTransactionList: [],
  refreshDashboard: false,
  reloadCount: 0,
  showFloatRefreshButton: false,
};

export const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_TRANSACTIONS_STARTED:
      return {
        ...state,
        transactionState: "loading",
        errorModal: false,
      };

    case types.FETCH_TRANSACTIONS_SUCCEDEED:
      localStorage.setItem("kudaRecents", JSON.stringify(action.payload.data));
      return {
          ...state,
          transactionList: action.payload.data,
          initialTransactionList: action.payload.data,
          transactionState: "success",
          errorModal: false,
          checkBalance: true,
      };

      case types.FETCH_FILTERED_TRANSACTIONS_STARTED:
        return {
          ...state,
          loadingFirestoreTransactionByDate: true,
          errorModal: false,
        };

    case types.FETCH_FILTERED_TRANSACTIONS_SUCCEDEED:
      return {
        ...state,
        transactionList: action.payload.data,
        errorModal: false,
        checkBalance: true,
        loadingFirestoreTransactionByDate: false,
        reloadCount: action.payload.reloadCount,
      };
      case types.FETCH_FILTERED_TRANSACTIONS_FAILED:
        return {
          ...state,
          loadingFirestoreTransactionByDate: false
        }
      case types.FETCH_NET_CASH_ANALYTICS_STARTED:
      return {
        ...state,
        netCashAnalyticsState: "loading",
        errorModal: false,
      }


    case types.FETCH_NET_CASH_ANALYTICS_SUCCEEDED:
       return {
         ...state,
         netCashAnalytics: action.payload.data,
         netCashAnalyticsState: "success",
         errorModal: false,
         netCashAnalyticsErrorCode: action.payload.code,
         netCashAnalyticsErrorMessage: action.payload.message
       }

       case types.FETCH_NET_CASH_ANALYTICS_FAILED:
       return {
         ...state,
         netCashAnalytics: {},
         netCashAnalyticsState: "failed",
         netCashAnalyticsErrorMessage: action.payload.message,
         netCashAnalyticsErrorCode: action.payload.code,
         errorModal: true,
       }
    case types.FETCH_TRANSACTIONS_FAILED:
      return {
        ...state,
        transactionState: "failed",
        errorModal: true,
        loadingFirestoreTransactionByDate: false
      };
    case types.REFRESH_PAYMENT_TRANSACTIONS_STARTED:
      return {
        ...state,
        refreshTransactionsState: "loading",
        errorModal: false,
      };
    case types.REFRESH_PAYMENT_TRANSACTIONS_SUCCESS:
      localStorage.setItem("kudaRecents", JSON.stringify(action.payload.data));
      return {
        ...state,
        transactionList: action.payload.data,
        initialTransactionList: action.payload.data,
        refreshTransactionsState: "success",
        errorModal: false,
      };
    case types.REFRESH_PAYMENT_TRANSACTIONS_FAILED:
      return {
        ...state,
        refreshTransactionsState: "failed",
        errorModal: true,
      };
    case types.LOAD_MORE_TRANSACTIONS_STARTED:
      return {
        ...state,
        loadMoreState: "loading",
      };
    case types.LOAD_MORE_TRANSACTIONS_SUCCEDEED: {
      const { concat, postingsHistory = [] } = action.payload;

      const newTransactionList = !concat
        ? postingsHistory
        : state.transactionList.concat(postingsHistory);

      return {
        ...state,
        loadMoreState: "success",
        transactionList: newTransactionList,
      };
    }
    case types.LOAD_MORE_TRANSACTIONS_FAILED:
      return {
        ...state,
        loadMoreState: "failed",
        errorMessage: action.payload.message,
      };
    case types.LOAD_MORE_SCHEDULED_TRANSACTIONS_STARTED:
      return {
        ...state,
        loadMoreScheduledTransactionState: "loading",
      };
    case types.LOAD_MORE_SCHEDULED_TRANSACTIONS_SUCCEEDED:
      return {
        ...state,
        loadMoreScheduledTransactionState: "success",
        scheduledPaymentsList: state.scheduledPaymentsList.concat(action.payload.data),
        totalScheduledPaymentsInStore: action.payload.totalRecordInStore,
      };
    case types.LOAD_MORE_SCHEDULED_TRANSACTIONS_FAILED:
      return {
        ...state,
        loadMoreScheduledTransactionState: "failed",
      };
    case types.CHANGE_BANK_START_DATE:
      return {
        ...state,
        bankStartDate: action.payload,
      };
    case types.CHANGE_BANK_END_DATE:
      return {
        ...state,
        bankEndDate: action.payload,
      };
    case types.GET_TRANSACTIONS_DATE_STARTED:
      return {
        ...state,
        loadTransactionsByDate: "loading",
      };
    case types.GET_TRANSACTIONS_DATE_SUCCEDEED:
      return {
        ...state,
        loadTransactionsByDate: "success",
        transactionList: action.payload.data,
        dateFilterTransactions: true,
      };
    case types.GET_TRANSACTIONS_DATE_FAILED:
      return {
        ...state,
        loadTransactionsByDate: "failed",
        errorMessage: action.payload.message,
      };
    case types.RESET_GET_TRANSACTIONS_DATE:
      return {
        ...state,
        loadTransactionsByDate: "idle",
        errorMessage: "",
      };
    case types.FETCH_BENEFICIARY_TRANSACTIONS_STARTED:
      return {
        ...state,
        singleBeneficiaryTransactionState: "loading",
      };
    case types.FETCH_BENEFICIARY_TRANSACTIONS_SUCCEDEED:
      localStorage.setItem(
        "beneficiaryTransactions",
        JSON.stringify(action.payload)
      );
      return {
        ...state,
        singleBeneficiaryTransactionState: "success",
        singleBeneficiaryTransactionsList: action.payload,
      };
    case types.FETCH_BENEFICIARY_TRANSACTIONS_FAILED:
      return {
        ...state,
        singleBeneficiaryTransactionState: "failed",
        // singleBeneficiaryTransactionsList: null
      };
    case types.LOAD_MORE_BENEFICIARY_TRANSACTIONS_STARTED:
      return {
        ...state,
        loadMoreBeneficiaryTransactionsState: "loading",
      };
    case types.LOAD_MORE_BENEFICIARY_TRANSACTIONS_SUCCEDEED:
      localStorage.setItem(
        "beneficiaryTransactions",
        JSON.stringify(action.payload)
      );
      return {
        ...state,
        loadMoreBeneficiaryTransactionsState: "success",
        singleBeneficiaryTransactionsList: state.singleBeneficiaryTransactionsList.concat(
          action.payload
        ),
      };
    case types.LOAD_MORE_BENEFICIARY_TRANSACTIONS_FAILED:
      return {
        ...state,
        loadMoreBeneficiaryTransactionsState: "failed",
      };
    case types.SET_DATE_FILTER_TRANSACTIONS:
      return {
        ...state,
        dateFilterTransactions: false,
      };
    case types.SET_EXPORT_OPTIONS:
      return {
        ...state,
        exportOptions: action.payload,
      };
    case types.SET_FILE_TYPE:
      return {
        ...state,
        fileType: action.payload,
      };
    case types.RESET_TRANSACTIONS:
      return {
        ...state,
        transactionList: state.initialTransactionList,
      };
    case types.SET_FILTER_START_DATE:
      return {
        ...state,
        filterStartDateValue: action.payload,
      };
    case types.SET_FILTER_END_DATE:
      return {
        ...state,
        filterEndDateValue: action.payload,
      };
    case types.EXPORT_TRANSACTIONS_STARTED:
      return {
        ...state,
        exportState: "loading",
      };
    case types.EXPORT_TRANSACTIONS_SUCCEDEED:
      return {
        ...state,
        exportState: "success",
      };
    case types.EXPORT_TRANSACTIONS_FAILED:
      return {
        ...state,
        exportState: "failed",
      };
    case types.SET_SINGLE_MODAL_DATA:
      return {
        ...state,
        singleTransactionInfo: state.transactionList.find(
          (item) => item.referenceNumber === action.payload
        ),
      };
    case types.GET_CATEGORIES_STARTED:
      return {
        ...state,
        getCategoriesState: "loading",
      };
    case types.GET_CATEGORIES_SUCCEDEED:
      return {
        ...state,
        getCategoriesState: "success",
        categories: action.payload,
      };
    case types.GET_CATEGORIES_FAILED:
      return {
        ...state,
        getCategoriesState: "failed",
      };
    case types.GET_TAGS_STARTED:
      return {
        ...state,
        getTagsState: "loading",
      };
    case types.GET_TAGS_SUCCEDEED:
      return {
        ...state,
        getTagsState: "success",
        tags: action.payload,
      };
    case types.GET_TAGS_FAILED:
      return {
        ...state,
        getTagsState: "failed",
      };
    case types.GET_SCHEDULED_PAYMENTS_STARTED:
      return {
        ...state,
        fetchScheduledPaymentsState: "loading",
      };
    case types.GET_SCHEDULED_PAYMENTS_SUCCEDEED:
      return {
        ...state,
        fetchScheduledPaymentsState: "success",
        scheduledPaymentsList: action.payload.data,
        totalScheduledPaymentsInStore: action.payload.totalRecordInStore,
      };
    case types.GET_SCHEDULED_PAYMENTS_FAILED:
      return {
        ...state,
        fetchScheduledPaymentsState: "failed",
      };
    case types.FETCH_BULK_TRANSACTION_SUCCEEDED:
      return {
        ...state,
        bulkTransactionList: action.payload
      }
    case types.SET_SINGLE_BULK_MODAL_DATA:
      return {
        ...state,
        singleTransactionInfo: state.bulkTransactionList.find(
          (item) => item.referenceNumber === action.payload
        ),
      }
    case types.RESET_CHECK_BALANCE:
      return {
        ...state,
        checkBalance: false,
        refreshDashboard: false,
        showFloatRefreshButton: false,
      }
    case types.UPDATE_OLD_TRANSACTION_LIST:
      return {
        ...state,
        oldTransactionList: action.payload
      }
    case types.REFRESH_DASHBOARD:
      return {
        ...state,
        refreshDashboard: true
      }
    case types.SHOW_FLOAT_REFRESH_BUTTON:
      return {
        ...state,
        showFloatRefreshButton: action.payload
      }
    default:
      return state;
  }
};
